module.exports = __webpack_public_path__ + "img/entia-portafolio-transmision-distribucion-1-en.2c4bb750.jpg";